import styled from 'styled-components';

export const SwitchWrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  padding: 5px 0px;
`;
